import React from "react";
import * as XLSX from "xlsx";
import { useRef } from "react";
import { useState } from "react";
import { convertExcelData, filterData, isInvalidFileData } from "../utils";
import { checkADBFileImported, importADB } from "src/apis/ADB/adb.api";
import { Notify } from "src/components/notify/Notify";
import { useEffect } from "react";

// handle File
const fileType = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

const ADBImport = ({ setIsLoading, onUploadSuccess }) => {
  const [fileName, setFileName] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);
  const [isImported, setIsImported] = useState(false);

  useEffect(() => {
    checkADBFileImported((result) => {
      setIsImported(result.isImported);
    });
  }, []);

  const fileInputRef = useRef(null);
  const handleChangeFile = () => {
    fileInputRef.current?.click();
  };

  const handleFile = (e) => {
    fileInputRef.current?.setAttribute("value", "");

    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          setExcelFile(e.target.result);
          setFileName(selectedFile.name);
        };
      } else {
        setExcelFileError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("plz select your file");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (excelFile !== null && !excelFileError) {
      const workbook = XLSX.read(excelFile, { type: "buffer" });
      const worksheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[worksheetName];
      const data = XLSX.utils.sheet_to_json(worksheet);

      if (isInvalidFileData(data[0])) {
        const dataHandled = [...convertExcelData(data)];

        const listProvinceFilter = filterData({
          data: dataHandled,
          key: "provinceCode",
          fields: ["provinceName", "provinceCode"],
        });

        const listDistrictFilter = filterData({
          data: dataHandled,
          key: "districtCode",
          fields: ["districtCode", "provinceCode", "districtName"],
        });

        const listWardFilter = filterData({
          data: dataHandled,
          key: "wardCode",
          fields: ["districtCode", "wardCode", "wardName"],
        });

        const dataRequest = {
          provinces: listProvinceFilter,
          districts: listDistrictFilter,
          wards: listWardFilter,
        };

        // call api create administrative
        importADB(dataRequest, (response) => {
          onUploadSuccess();
        });

        setExcelFile(null);
        setFileName(null);
      } else {
        Notify("warning", "Vui lòng chọn file device hợp lệ");
      }
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <input
        style={{ display: "none" }}
        type="file"
        className="form-control"
        onChange={handleFile}
        required
        placeholder="import file excel"
        ref={fileInputRef}
        onClick={(event) => {
          event.target.value = null;
        }}
      ></input>

      {fileName && (
        <div className="text-danger" style={{ marginTop: 5 + "px" }}>
          {fileName}
        </div>
      )}
      {!isImported && (
        <button
          type="button"
          onClick={handleChangeFile}
          className="btn btn-success"
          style={{ marginTop: 5 + "px" }}
        >
          Import file
        </button>
      )}
      {excelFile !== null && (
        <button
          type="submit"
          className="btn btn-success"
          style={{ marginTop: 5 + "px" }}
          onClick={handleSubmit}
        >
          Submit
        </button>
      )}
    </div>
  );
};

export default ADBImport;
